export default String.raw`
{% assign emailReadonly = false -%}
{% assign emailRequired = false -%}
{% assign TINTooltipVisible = false -%}
{% assign euCountriesISOWithoutPL = "AT|BE|BG|HR|CY|CZ|DK|EE|FI|FR|DE|GR|HU|IE|IT|LV|LT|LU|MT|NL|PT|RO|SK|SI|ES|SE" -%}

{% if include contains 'retail' or include == 'company' -%}
	{% if include == 'company' -%}
		{% assign chosenType = config.Registration.Company -%}
		{% assign company = true -%}
		{% assign TINVisible = true -%}
		{% assign tin = customer.TIN -%}
		{% assign vateu = customer.VATEU -%}
		{% assign countryISOCode = config.Countries[0].ISOCode -%}
	{% else -%}
		{% assign chosenType = config.Registration.Retail -%}
		{% if include contains '=' -%}
			{% assign includeArr = include | Split:'=' -%}
			{% assign countryISOCode = includeArr[1] -%}
		{% else -%}
			{% assign countryISOCode = config.Countries[0].ISOCode -%}
		{% endif -%}
		{% assign countryChangeReload = true -%}
		{% assign dataContainer = '.register-js' -%}
		{% assign dataInclude = 'retail=' -%}
	{% endif -%}
	{% assign addressVisible = chosenType.AddressVisible -%}
	{% assign addressRequired = chosenType.AddressRequired -%}
	{% assign phoneVisible = chosenType.PhoneVisible -%}
	{% assign phoneRequired = chosenType.PhoneRequired -%}
	{% assign address = customer.Address -%}
{% elseif include contains 'add-da' -%}
	{% if customer.Company -%}
		{% assign company = true -%}
		{% assign TINVisible = false -%}
	{% endif -%}
	{% assign addressVisible = true -%}
	{% assign addressRequired = true -%}
	{% assign phoneVisible = true -%}
	{% assign phoneRequired = true -%}
	{% assign includeArr = include | Split:'=' -%}
	{% assign countryISOCode = includeArr[1] -%}
	{% assign countryChangeReload = true -%}
	{% assign dataContainer = '.add-da-js' -%}
	{% assign dataInclude = 'add-da=' -%}
{% elseif include contains 'customer-data' -%}
	{% assign chosenType = config.Registration.Retail -%}
	{% if customer.Company -%}
		{% assign company = true -%}
		{% assign TINVisible = true -%}
		{% assign tin = customer.TIN -%}
		{% assign vateu = customer.VATEU -%}
		{% assign chosenType = config.Registration.Company -%}
	{% endif -%}
	{% assign emailRequired = true -%}
	{% assign email = customer.Address.Email -%}
	{% assign addressVisible = true -%}
	{% assign addressRequired = true -%}
	{% assign phoneVisible = true -%}
	{% assign phoneRequired = chosenType.PhoneRequired -%}
	{% assign address = customer.Address -%}
	{% assign includeArr = include | Split:'=' -%}
	{% assign countryISOCode = includeArr[1] -%}
	{% assign countryChangeReload = true -%}
	{% assign dataContainer = '.customer-data-address-js' -%}
	{% assign dataInclude = 'customer-data=' -%}
	{% assign showAdditionalPersonData = true -%}
	{% if countryISOCode == 'PL' -%}
		{% if settings.editDataFromGUS == 'no' and customer.Company -%}
			{% assign readonly = true -%}
		{% endif -%}
		{% assign gus = true -%}
	{% else -%}
		{% assign euCountriesISOWithoutPLArray = euCountriesISOWithoutPL | Split: '|' -%}
		{% for euCountryISO in euCountriesISOWithoutPLArray -%}
			{% if countryISOCode == euCountryISO -%}
				{% if settings.editDataFromVIES == 'no' and customer.Company -%}
					{% assign readonly = true -%}
				{% endif -%}
				{% break -%}
			{% endif -%}
		{% endfor -%}
	{% endif -%}
{% elseif include contains '|' -%}
	{% comment -%}<!--da-->{% endcomment -%}
	{% if customer.Company -%}
		{% assign company = true -%}
		{% assign TINVisible = false -%}
	{% endif -%}
	{% assign addressVisible = true -%}
	{% assign addressRequired = true -%}
	{% assign phoneVisible = true -%}
	{% assign phoneRequired = true -%}
	{% assign incSplit = include | Split:'|' -%}
	{% assign daId = incSplit[0] | ToInt -%}
	{% assign address = customer.DeliveryAddresses[daId] -%}
	{% assign incSplitSize = incSplit | Size -%}
	{% if incSplitSize > 1 -%}
		{% assign countryISOCode = incSplit[1] -%}
	{% endif -%}
	{% assign countryChangeReload = true -%}
	{% assign dataContainer = '.da-js' -%}
	{% capture dataInclude -%}{{address.Id}}|{% endcapture -%}
{% else -%}
	{% if customer.Company -%}
		{% assign company = true -%}
		{% assign TINVisible = true -%}
		{% assign tin = customer.TIN -%}
		{% assign vateu = customer.VATEU -%}
	{% endif -%} 
	{% assign emailRequired = true -%}
	{% assign email = customer.Address.Email -%}
	{% assign addressVisible = true -%}
	{% assign addressRequired = true -%}
	{% assign phoneVisible = true -%}
	{% assign phoneRequired = true -%}
	{% assign address = customer.Address -%}
	{% assign countryISOCode = config.Countries[0].ISOCode -%}
{% endif -%}

{% assign cityRequired = config.Countries[countryISOCode].RequiredFields.City -%}
{% assign streetRequired = config.Countries[countryISOCode].RequiredFields.Street -%}
{% assign streetNoRequired = config.Countries[countryISOCode].RequiredFields.StreetNo -%}
{% assign zipCodeRequired = config.Countries[countryISOCode].RequiredFields.ZipCode -%}
{% assign TINRequired = config.Countries[countryISOCode].RequiredFields.TIN -%}

{% if include contains 'inv-add' or page.QueryString contains 'invoice-address' -%}
	{% if customer.Company -%}
		{% assign TINRequired = true -%}
	{% else -%}
		{% assign TINRequired = false -%}
		{% assign TINTooltipVisible = true -%}
	{% endif -%}
{% endif -%}

{% if addressVisible -%}
	<div class="{% if company -%} company-form-js {% else -%} retail-form-js {% endif -%}">
		{% if recipe -%}
		<div class="recipe-js form-js {% if showRecipe != true -%} hidden-js {% endif -%}" style="margin-top: 27px;">
			<div>{{ translations.WantToGetRecipeInfo }}</div>
			{% if config.ENTERPRISE and company -%}
				{% for v in config.VATEU -%}
					{% if v.ISOCode == countryISOCode -%}
						{% assign vateuExists = true -%}
						{% break -%}
					{% endif -%}
				{% endfor -%}
				{% if vateuExists -%}
				<div class="reg-container__input-wrappers-city">
					<div class="form__input-wrapper">
						<label for="vateu" class="form__input-info input-info-js">{{ translations.CountryCode }}</label>
						<select aria-label="{{ translations.CountryCode }}" name="vateu" class="form__input-value input-value-js reg-container__select registration-tin-js">
							<option value="" label=" "></option>
						{% for v in config.VATEU -%}
							{% if v.ISOCode == countryISOCode -%}
							<option value="{{ v.Value }}" {% if v.Value == vateu -%} selected {% endif -%}>{{ v.Name }}</option>
							{% endif -%}
						{% endfor -%}
						</select>
					</div>
				</div>
				{% endif -%}
			{% endif -%}
				{% unless vateuExists -%}
				<div class="form__input-wrapper">
					<label for="tin" class="form__input-info input-info-js">{{ translations.TIN }}</label>
				</div>
				{% endunless -%}
				<input class="form__input-value input-value-js" id="tin" type="text" name="tin" value="{{ tin }}" data-check-sum="{% if countryISOCode == 'PL' -%}true{% else -%}false{% endif -%}" maxlength="20">
				<div class="form__invalid-input validation-info-js validation-tin-js hidden-js tin-validation-check-js">{{ translations.FillProperTIN }}</div>
				<div class="form__invalid-input validation-info-js validation-gus-js hidden-js tin-validation-check-js">{{ translations.NoTINinGUS }}</div>
				<div class="form__invalid-input validation-info-js validation-gus-allow-when-not-responding-js hidden-js tin-validation-check-js">{{ translations.GUSErrorFillData }}</div>
				<div class="form__invalid-input validation-info-js validation-gus-dont-allow-when-not-responding-js hidden-js tin-validation-check-js">{{ translations.GUSErrorTryLater }}</div>
				<div class="form__invalid-input validation-info-js validation-vies-js hidden-js allow-not-hidden-js tin-validation-check-js">{{ translations.NoTINinVIES }}</div>
				<div class="form__invalid-input validation-info-js validation-vies-allow-when-not-responding-js hidden-js allow-not-hidden-js tin-validation-check-js">{{ translations.VIESErrorFillData }}</div>
				<div class="form__invalid-input validation-info-js validation-vies-dont-allow-when-not-responding-js hidden-js allow-not-hidden-js tin-validation-check-js">{{ translations.VIESErrorTryLater }}</div>
			{% if vateuExists -%}
		</div>
	</div>
			{% endif -%}
		</div>
		<div class="form-js invoice-js {% if showRecipe -%} hidden-js {% endif -%}">
        {% endif -%}
        {% if emailRequired -%}
		<div class="form__input-wrapper">
			<label for="email" class="form__input-info input-info-js"><span class="required">* </span>{{ translations.Email }}</label>
			<input class="form__input-value input-value-js onlyInputEventValidation" id="email" type="email" name="email" value="{{email}}" autocomplete="email" maxlength="192" required {% if email != '' and emailReadonly -%} readonly {% endif -%}>
			<div class="form__invalid-input validation-info-js validation-required-js hidden-js">{{ translations.FillEmail }}</div>
			<div class="form__invalid-input validation-info-js email-valid-js hidden-js">{{ translations.FillProperEmail }}</div>
		</div>
        {% endif -%}     
		<div class="form__input-wrapper form__input-wrapper__country">
			<label for="countryCode-1" class="form__input-info input-info-js country">{{ translations.Country }}</label>
			{% assign countriesSize = config.Countries | Size -%}
			{% if include != 'orderDa' and countriesSize > 1 -%}
				<select id="countryCode-1" aria-label="{{ translations.Country }}" name="countryCode" class="form__input-value input-value-js reg-container__select {% if countryChangeReload -%} validate-after-replace-js {% endif -%}" {% if countryChangeReload -%} data-template="partials/common/address-form.html" data-container="{{dataContainer}}" {% endif -%}>
					{% for country in config.Countries -%}
						<option {% if country.ISOCode == config.Countries[0].ISOCode or country.ISOCode == countryISOCode -%} selected {% endif -%} value="{{ country.ISOCode }}" data-tin-regex="{{ country.TINRegex }}" data-zip-regex="{{ country.ZipCodeRegex }}" data-zip-format="{{ country.ZipCodeFormat }}" {% if countryChangeReload -%} data-include="{{dataInclude}}{{ country.ISOCode }}" {% endif -%} >
							{{ config.Countries[country.ISOCode].Name }}
						</option>
					{% endfor -%}
				</select>
			{% else -%}
				{% for country in config.Countries -%}
					{% if country.ISOCode == countryISOCode -%}
				<input id="countryCodeID-1" class="form__input-value input-value-js" aria-label="{{ config.Countries[country.ISOCode].Name }}" type="text" value="{{ config.Countries[country.ISOCode].Name }}" disabled readonly>
				<input id="countryCodeID-2" class="form__input-value input-value-js" aria-label="{{ country.ISOCode }}" type="hidden" name="countryCode" value="{{ country.ISOCode }}" {% if addressRequired -%} required {% endif -%} data-tin-regex="{{ country.TINRegex }}" data-zip-regex="{{ country.ZipCodeRegex }}" data-zip-format="{{ country.ZipCodeFormat }}">
					{% endif -%}
				{% endfor -%}
			{% endif -%}
			{% if addressRequired -%}
				<div class="form__invalid-input validation-required-js hidden-js">{{ translations.FillCountry }}</div>
			{% endif -%}
		</div>   
		{% if TINVisible -%}
			{% if config.ENTERPRISE and company -%}
				{% for v in config.VATEU -%}
					{% if v.ISOCode == countryISOCode -%}
						{% assign vateuExists = true -%}
						{% break -%}
					{% endif -%}
				{% endfor -%}
				{% if vateuExists -%}
		<div class="reg-container__input-wrappers-city">
			<div class="form__input-wrapper">
				<label for="vateu" class="form__input-info input-info-js">{{ translations.CountryCode }}</label>
					<select aria-label="{{ translations.CountryCode }}" name="vateu" class="form__input-value input-value-js reg-container__select registration-tin-js">
						<option value="" label=""></option>
						{% for v in config.VATEU -%}
							{% if v.ISOCode == countryISOCode -%}
								<option value="{{ v.Value }}" {% if v.Value == vateu -%} selected {% endif -%}>{{ v.Name }}</option>
							{% endif -%}
						{% endfor -%}
					</select>
			</div>
				{% endif -%}
			{% endif -%}
			<div class="form__input-wrapper">
				<label for="tin" class="form__input-info input-info-js">{% if TINRequired -%}<span class="required">* </span>{% endif -%}{{ translations.TIN }}{% if TINTooltipVisible -%}<i class="ti-info-alt" title="{{translations.TINTooltipInfo}}"></i>{% endif -%}</label>
				<input class="form__input-value input-value-js" id="tin" type="text" name="tin" value="{{ tin }}" {% if TINRequired -%} required {% endif -%} data-check-sum="{% if countryISOCode == 'PL' -%}true{% else -%}false{% endif -%}" maxlength="20">
			{% if TINRequired -%}
				<div class="form__invalid-input validation-required-js tin-validation-check-js hidden-js">{{ translations.FillTIN }}</div>
			{% endif -%}
				<div class="form__invalid-input validation-info-js validation-tin-js hidden-js tin-validation-check-js">{{ translations.FillProperTIN }}</div>
				<div class="form__invalid-input validation-info-js validation-gus-js hidden-js tin-validation-check-js">{{ translations.NoTINinGUS }}</div>
				<div class="form__invalid-input validation-info-js validation-gus-allow-when-not-responding-js hidden-js tin-validation-check-js">{{ translations.GUSErrorFillData }}</div>
				<div class="form__invalid-input validation-info-js validation-gus-dont-allow-when-not-responding-js hidden-js tin-validation-check-js">{{ translations.GUSErrorTryLater }}</div>
				<div class="form__invalid-input validation-info-js validation-vies-js hidden-js allow-not-hidden-js tin-validation-check-js">{{ translations.NoTINinVIES }}</div>
				<div class="form__invalid-input validation-info-js validation-vies-allow-when-not-responding-js hidden-js allow-not-hidden-js tin-validation-check-js">{{ translations.VIESErrorFillData }}</div>
				<div class="form__invalid-input validation-info-js validation-vies-dont-allow-when-not-responding-js hidden-js allow-not-hidden-js tin-validation-check-js">{{ translations.VIESErrorTryLater }}</div>
			{% if vateuExists -%}
			</div>
		</div>
			{% else -%}
			</div>
			{% endif -%}
		{% endif -%}
		{% if company -%}
		<div class="form__input-wrapper">
            <label for="company-name" class="form__input-info input-info-js"><span class='required'>* </span>{{ translations.CompanyName }}</label>
            <input id="company-name" class="form__input-value input-value-js" type="text" name="name" value="{{ address.Name | H }}" maxlength="50" required {% if readonly -%} readonly {% endif -%}>
            <div class="form__invalid-input validation-required-js hidden-js">
                {{ translations.FillCompanyName }}
            </div>
        </div>
        <div class="form__input-wrapper" name="name2">
            <label for="company-name2" class="form__input-info input-info-js">{{ translations.CompanyName }}</label>
            <input id="company-name2" class="form__input-value input-value-js" type="text" name="name2" autocomplete="customer-name-2" value="{{ address.Name2 | H }}" maxlength="50" {% if readonly -%} readonly {% endif -%}>
        </div>
        {% else -%}
		<div class="form__input-wrapper">
			<label for="name" class="form__input-info input-info-js"><span class="required">* </span>{{ translations.NameAndSurname }} </label>
			<input id="name" class="form__input-value input-value-js" type="text" name="name" value="{{ address.Name | H }}" maxlength="50" required {% if readonly -%} readonly {% endif -%} >
			<div class="form__invalid-input validation-required-js hidden-js">{{ translations.FillNameAndSurname }}</div>
		  </div>
		<div class="form__input-wrapper">
			<label for="name2" class="form__input-info input-info-js">{{ translations.NameAndSurname }}</label>
			<input id="name2" class="form__input-value input-value-js" type="text" name="name2" autocomplete="customer-name-2" value="{{ address.Name2 | H }}" maxlength="50" {% if readonly -%} readonly {% endif -%} >
		</div>
        {% endif -%}
        <div class="form__input-wrapper">
			<label for="street" class="form__input-info input-info-js">{% if addressRequired and streetRequired -%}<span class="required">* </span>{% endif -%}{{ translations.Street }} </label>
			<input id="street" class="form__input-value input-value-js" type="text" name="street" value="{{ address.Street | H }}" maxlength="50" {% if addressRequired and streetRequired -%} required {% endif -%} {% if readonly -%} readonly {% endif -%} >
			{% if addressRequired and streetRequired -%}
				<div class="form__invalid-input validation-required-js hidden-js">{{ translations.FillStreet }}</div>
			{% endif -%}
	  	</div>
		<div class="reg-container__input-wrappers-home">
            <div class="form__input-wrapper">
				<label for="streetNo" class="form__input-info input-info-js">{% if addressRequired and streetNoRequired -%}<span class="required">* </span>{% endif -%}{{ translations.HouseNumber }}</label>
              	<input id="streetNo" class="form__input-value input-value-js" type="text" name="streetNo" value="{{ address.StreetNo }}" maxlength="20" {% if addressRequired and streetNoRequired -%} required {% endif -%} {% if readonly -%} readonly {% endif -%} >
              	{% if addressRequired and streetNoRequired -%}
      	        	<div class="form__invalid-input validation-required-js hidden-js">{{ translations.FillHouseNumber }}</div>
              	{% endif -%}
            </div>
            <div class="form__input-wrapper">
              	<label for="unitNo" class="form__input-info input-info-js">{{ translations.FlatNumber }}</label>
              	<input id="unitNo" class="form__input-value input-value-js" type="text" name="unitNo" value="{{ address.UnitNo }}" maxlength="20" {% if readonly -%} readonly {% endif -%} >
              	<div class="form__invalid-input validation-required-js hidden-js">{{ translations.FillFlatNumber }}</div>
            </div>
        </div>
        <div class="reg-container__input-wrappers-city">
            <div class="form__input-wrapper">
                <label for="zipCode" class="form__input-info input-info-js">{% if addressRequired and zipCodeRequired -%}<span class="required">* </span>{% endif -%}{{ translations.ZipCode }}</label>
                <input id="zipCode" class="form__input-value input-value-js" {% if showMapTrigger -%} class="show-map-js" {% endif -%} type="text" name="zipCode" value="{{ address.ZipCode }}" {% if addressRequired and zipCodeRequired -%} required {% endif -%} {% if readonly -%} readonly {% endif -%} maxlength="20" >
                {% if addressRequired and zipCodeRequired -%}
                    <div class="form__invalid-input validation-required-js hidden-js">{{ translations.FillZipCode }}</div>
                {% endif -%}
                <div class="form__invalid-input validation-zip-code-js hidden-js">{{ translations.FillProperZipCode }} <span class="zip-format-js"></span></div>
            </div>
            <div class="form__input-wrapper">
                <label for="city" class="form__input-info input-info-js">{% if addressRequired and cityRequired -%}<span class="required">* </span>{% endif -%}{{ translations.City }} </label>
                <input id="city" class="form__input-value input-value-js" type="text" name="city" value="{{ address.City | H }}" maxlength="50" {% if addressRequired and cityRequired -%} required {% endif -%} {% if readonly -%} readonly {% endif -%} >
                {% if addressRequired and cityRequired -%}
                    <div class="form__invalid-input validation-required-js hidden-js">{{ translations.FillCity }}</div>
                {% endif -%}
            </div>
        </div>
        {% if phoneVisible -%}
		<div class="form__input-wrapper {% if company -%} company-form-js {% else -%} retail-form-js {% endif -%}">
			<label for="phoneNo" class="form__input-info input-info-js">{% if phoneRequired -%}<span class="required">* </span>{% endif -%}{{ translations.PhoneNumber }}</label>
			<input id="phoneNo" class="form__input-value input-value-js" type="tel" inputmode="numeric" pattern="\d*" name="phoneNo" value="{{ address.PhoneNo }}" maxlength="20" data-error="{{ translations.FillPhoneNumber }}" {% if phoneRequired -%} required {% endif -%} >
			{% if phoneRequired -%}
			<div class="form__invalid-input validation-info-js validation-required-js hidden-js">{{ translations.FillPhoneNumber }}</div>
			{% endif -%}
			<div class="form__invalid-input validation-info-js phone-valid-js hidden-js">{{ translations.FillProperPhoneNumber }}</div>
		</div>
		{% endif -%}

		{% if page.PageId == config.DefinedPages.Registration.Id and include == "retail" -%}
			{% assign showAdditionalPersonDataVariable = true %}
			{% elseif page.PageId == config.DefinedPages.CustomerProfile.Id and showAdditionalPersonData == true and customer.Company == false -%}
			{% assign showAdditionalPersonDataVariable = true %}
		{% else -%}
			{% assign showAdditionalPersonDataVariable = false %}
		{% endif -%}

		{% if page.PageId == config.DefinedPages.Registration.Id and include == "retail" -%}
			{% assign showAdditionalPersonDataVariable = true %}
		{% elseif page.PageId == config.DefinedPages.CustomerProfile.Id and showAdditionalPersonData == true and customer.Company == false -%}
			{% assign showAdditionalPersonDataVariable = true %}
		{% else -%}
			{% assign showAdditionalPersonDataVariable = false %}
		{% endif -%}

		{% if showAdditionalPersonDataVariable == true -%}
			{% if config.Registration.Retail.BirthDateVisible == true and config.Registration.Retail.GenderVisible == true -%}
		<div class="reg-container__input-wrappers-personal-data">
			{% else -%}
		<div>
		{% endif -%}
			{% if config.Registration.Retail.BirthDateVisible == true -%}
			<div class="form__input-wrapper">
				<label for="birthdate" class="form__input-info input-info-js date"><span class='required'>{% if config.Registration.Retail.BirthDateRequired == true -%}* {% endif -%}</span>{{ translations.BirthDate }}</label>
				<input id="birthdate" class="form__input-value input-value-js" type="date" name="birthdate" max={{config.Now|Date:'yyyy-MM-dd'}} {% if config.Registration.Retail.BirthDateRequired == true -%} required {% endif -%} {% if customer.BirthDate != null -%} value = {{ customer.BirthDate|Date:'yyyy-MM-dd'}} {% else -%} value="" {% endif -%} >
				<div class="form__invalid-input validation-info-js validation-required-js hidden-js">{{ translations.FieldRequired }}</div>
			</div>
			{% endif -%}
			{% if config.Registration.Retail.GenderVisible == true -%}
			<div class="form__input-wrapper">
				<label for="gender" class="form__input-info input-info-js"><span class='required'>{% if config.Registration.Retail.GenderRequired == true -%}* {% endif -%}</span>{{ translations.Gender }}</label>
					<select id="gender" type="gender" name="gender" class="form__input-value input-value-js reg-container__select" {% if config.Registration.Retail.GenderRequired == true -%} required{% endif -%}>
						<option value="" disabled hidden {% if customer.Gender == null -%} selected {% endif %} ></option>
						<option aria-label="{{ translations.PreferNotToSay }}" value="2" {% if customer.Gender == 2 -%} selected {% endif -%}>{{ translations.PreferNotToSay }}</option>
						<option aria-label="{{ translations.Male }}" value="1" {% if customer.Gender == 1 -%} selected {% endif -%} > {{ translations.Male }} </option>
						<option aria-label="{{ translations.Female }}" value="0" {% if customer.Gender == 0 -%} selected {% endif -%}> {{ translations.Female }} </option>
					</select>
					<div class="form__invalid-input validation-info-js validation-required-js hidden-js">{{ translations.FieldRequired }}</div>
			</div>
			{% endif -%}
		</div>
		{% endif -%}

		{% if recipe -%}
		</div>
		{% endif -%}
	</div>
{% endif -%}
`